// --- Vendors ---
import Swiper from 'swiper';
import { Thumbs, Navigation } from 'swiper/modules';

// Enregistrement unique des modules
Swiper.use([Thumbs, Navigation]);

const singleRealisation = {
    readyFn: function () {
        console.log("Single Produit ready");

        const $mainSlider = document.querySelector('.MainSwiper');
        const $thumbsSlider = document.querySelector('.swiper-thumbs');
        const $colorOptions = document.querySelectorAll('.wrapper-option .option');
        const $colorNameDisplay = document.querySelector('.selected-color-name');

        if (!$mainSlider || !$thumbsSlider) return;

        // 1. Initialisation des miniatures (DOIT ÊTRE FAIT EN PREMIER)
        const swiperThumbs = new Swiper($thumbsSlider, {
            spaceBetween: 10,
            slidesPerView: 3.2,
            freeMode: true,
            watchSlidesProgress: true,
        });

        // 2. Initialisation du Swiper Principal
        const swiperMain = new Swiper($mainSlider, {
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: swiperThumbs,
            },
            // Écouteur : Quand le swiper change (flèches/swipe), on met à jour les boutons couleurs
            on: {
                slideChange: function () {
                    singleProduit.updateColorOptions(this.activeIndex, $colorOptions, $colorNameDisplay);
                }
            }
        });

        // 3. Gestion du clic sur les boutons couleurs (Colonne de droite)
        $colorOptions.forEach(option => {
            option.addEventListener('click', () => {
                const targetIndex = parseInt(option.getAttribute('data-color-index'));
                const colorName = option.getAttribute('data-color-name');

                // Changer la slide du Swiper principal
                swiperMain.slideTo(targetIndex);

                // Mettre à jour visuellement les boutons immédiatement
                singleProduit.updateColorOptions(targetIndex, $colorOptions, $colorNameDisplay, colorName);
            });
        });
    },

    // Fonction utilitaire pour mettre à jour la classe 'active' et le nom
    updateColorOptions: function (activeIndex, options, nameDisplay, forcedName = null) {
        options.forEach(opt => {
            const optIndex = parseInt(opt.getAttribute('data-color-index'));

            if (optIndex === activeIndex) {
                opt.classList.add('active');
                if (nameDisplay) {
                    const name = forcedName || opt.getAttribute('data-color-name');
                    if (name) nameDisplay.textContent = name;
                }
            } else {
                opt.classList.remove('active');
            }
        });
    }
};

export { singleRealisation };